var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      this.$store.getters['user/getUser'].role === 'admin' ||
      this.$store.getters['user/getUser'].role === 'redactor'
    )?_c('blog-component'):_vm._e(),(
      this.$store.getters['user/getUser'].role === 'psychologist' ||
      this.$store.getters['user/getUser'].role === 'patient'
    )?_c('public-blog'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }